




































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import Card from '@/components/Card.vue';

@Component({
    components: {
        Card
    }
})
export default class extends Vue {
    @Prop() TypesToggle: boolean | undefined;
    @Prop() dataExpense: Tag[] | undefined;
    @Prop() dataIncome: Tag[] | undefined;
    @Prop() SelectedTypeName: string | undefined;
    @Prop({default: '+'}) SelectedType: string | undefined;

    SetTypeClass2(item: string) {
        this.$emit('update:SelectedTypeName', item);
        this.$emit('update:TypesToggle', false);
    }

    SetTypeClass(item: Tag, type: '-' | '+') {
        if(type==='-'){
            this.$emit('update:SelectedType','-')
        }else {
            this.$emit('update:SelectedType','+')
        }
        this.$emit('update:SelectedTypeName', item.name);
        this.$emit('update:TypesToggle', false);


    }

    xxx() {
        this.$emit('update:TypesToggle', false);
    }

}
